import axios from "axios";

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    return decodeURIComponent(parts.pop().split(";").shift());
  }

  return null;
}

const api = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL_VERSION,
  withCredentials: true,
  headers: {
    Accept: "application/json",
    "X-Requested-With": "XMLHttpRequest",
  },
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  withXSRFToken: true,
});

api.interceptors.request.use((config) => {
  const method = config.method?.toLowerCase();

  if (["post", "put", "patch", "delete"].includes(method)) {
    const token = getCookie("XSRF-TOKEN");
    console.log({token});

    if (token) {
      config.headers["X-XSRF-TOKEN"] = token;
    }
  }

  return config;
});

export default api;
